/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Color_PinkInputs */

const en_booking_color_pink = /** @type {(inputs: Booking_Color_PinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pink`)
};

const pl_booking_color_pink = /** @type {(inputs: Booking_Color_PinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Różowy`)
};

/**
* | output |
* | --- |
* | "Pink" |
*
* @param {Booking_Color_PinkInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_color_pink = /** @type {((inputs?: Booking_Color_PinkInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Color_PinkInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_color_pink(inputs)
	return en_booking_color_pink(inputs)
});